import React, { useEffect, useState } from "react";
import CompanyInformationStep from "../../organisms/CompanyInformationStep";
import useStepPersistence from "../../Hooks/useStepPersistience";
import axios, * as Http from "../../../Http";
const CompanyInformationContainer = ({ formData, setFormStep, user, errors, loading, setPreviousStep, index, }) => {
    const [companyInformationLoading, setCompanyInformationLoading] = useState(false);
    const [data, handleChange, handleSubmit, patch] = useStepPersistence({
        company_kvk_number: "",
        company_name: "",
        company_postal_code: "",
        company_house_number: null,
        company_house_number_addition: "",
        company_street: "",
        company_city: "",
        company_phone_number: "",
        company_email: "",
        company_income_tax_number: "",
        company_acknowledgement: false,
    }, formData, setFormStep);
    useEffect(() => {
        if (!Object.keys(formData).length || formData.company_name) {
            return;
        }
        setCompanyInformationLoading(true);
        axios
            .get(Http.COMPANY)
            .then((data) => {
            patch({
                company_kvk_number: data.data.chamber_of_commerce_number,
                company_name: data.data.name,
                company_postal_code: data.data.postal_code,
                company_house_number: data.data.house_number,
                company_house_number_addition: data.data.house_number_addition,
                company_street: data.data.street,
                company_city: data.data.city,
                company_phone_number: data.data.phone_number,
                company_email: data.data.email,
                company_income_tax_number: data.data.income_tax_number,
            });
            setCompanyInformationLoading(false);
        })
            .catch(() => {
            setCompanyInformationLoading(false);
        });
    }, [formData]);
    return (React.createElement(CompanyInformationStep, { onSubmit: handleSubmit, onChange: handleChange, data: Object.assign(Object.assign({}, formData), data), user: user, errors: errors, loading: loading || companyInformationLoading, companyInformationLoading: companyInformationLoading, setPreviousStep: setPreviousStep, index: index, patch: patch }));
};
export default CompanyInformationContainer;
